import { Route, Routes } from "react-router-dom";
import { AccessRequest } from "./list";
import { EditRequest } from "./edit";
import { CreateRequest } from "./create";

export default function BackOfficeAccessRequestRoutes() {
  return (
    <Routes>
      <Route path="/" element={<AccessRequest />} />
      <Route path="/:id_request/editar" element={<EditRequest />} />
      <Route path="/criar" element={<CreateRequest />} />
    </Routes>
  );
}
